import React from 'react'
import styles from './unitAdd.jcss'
import EditText from '../../../blocks.simple/editText/editText'
import translate from '../../../core/translate'
import Button from '../../../blocks.simple/button/button'
import CatalogSelectContent from '../../../blocks.app/catalog/_select/_content/catalog_select_content'
import CatalogSelectDevices from '../../../blocks.app/catalog/_select/_devices/catalog_select_devices'
import Icon from '../../../blocks.simple/icon/icon'
import Dropdown from '../../../blocks.simple/dropdown/dropdown'

export const UnitAdd = ({ unit, onChange, onClose, onSave }: any) => {
    const onFloorNameChange = (value: string, id: number) => {
        onChange(
            'floorList',
            unit.floorList.map((floor: any) => {
                if (floor.id === id) {
                    return {
                        ...floor,
                        name: value,
                    }
                }

                return floor
            })
        )
    }
    const onDSListChange = (list: any, index: number) => {
        const changedFloorList = unit.floorList.map((item: any, _index: number) => {
            if (index === _index) {
                return {
                    ...item,
                    digitalSignages: list,
                }
            }

            return item
        })

        onChange('floorList', changedFloorList)
    }
    const onFloorAdd = () => {
        onChange('floorList', [...unit.floorList, { id: Math.random(), name: '', digitalSignages: [], groups: [] }])
    }
    const onFloorDelete = (index: number) => {
        onChange(
            'floorList',
            unit.floorList.filter((floor: any, _index: number) => _index !== index)
        )
    }
    const isValid = () => {
        return (
            !unit.unitName ||
            !unit.officeCode ||
            !unit.unitCode ||
            !unit.floorList.length ||
            unit.floorList.some((floor: any) => !floor.name)
        )
    }

    return unit ? (
        <div className={styles.unitAdd}>
            <div>
                <div className={styles.inner}>
                    <div className={styles.field}>
                        <EditText
                            value={unit.unitName}
                            onChange={(value: string) => {
                                onChange('unitName', value)
                            }}
                            containerClass={styles.separator}
                            className={styles.input}
                            label={translate('unitName')}
                        />
                    </div>
                    <div className={styles.field}>
                        <EditText
                            value={unit.officeCode}
                            onChange={(value: string) => {
                                onChange('officeCode', value)
                            }}
                            containerClass={styles.separator}
                            className={styles.input}
                            label={translate('officeCode')}
                        />
                    </div>
                    <div className={styles.field}>
                        <EditText
                            value={unit.unitCode}
                            onChange={(value: string) => {
                                onChange('unitCode', value)
                            }}
                            containerClass={styles.separator}
                            className={styles.input}
                            label={translate('unitCode')}
                        />
                    </div>
                    {/*<div className={styles.field}>*/}
                    {/*    <CatalogSelectContent*/}
                    {/*        label={translate('content')}*/}
                    {/*        type={'image'}*/}
                    {/*        selectedInfo={unit.content ? unit.content : null}*/}
                    {/*        onSelect={(selectedMedia: { id: number; src: string }) => {*/}
                    {/*            onChange('content', selectedMedia)*/}
                    {/*        }}*/}
                    {/*        selectedItemStyles={{ width: 70, marginRight: 20 }}*/}
                    {/*        itemStyles={styles.itemStyles}*/}
                    {/*        className={styles.selectLogo}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    {/*<div className={styles.field}>*/}
                    {/*    <Dropdown*/}
                    {/*        mod={'default'}*/}
                    {/*        options={[{ id: 1, title: 'fire_alert' }]}*/}
                    {/*        valueField={'title'}*/}
                    {/*        labelField={'title'}*/}
                    {/*        placeholder={translate('notSelected')}*/}
                    {/*        label={translate('contentNotificationType')}*/}
                    {/*        value={unit.notificationType}*/}
                    {/*        onChange={(value: any) => onChange('category', value)}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    <div className={styles.field}>
                        <div className={styles.floorTitle}>{translate('floors')}</div>
                        {unit.floorList.map((floor: any, index: number) => {
                            return (
                                <div className={styles.floor}>
                                    <div className={styles.deleteFloor} onClick={() => onFloorDelete(index)}>
                                        <Icon type={'delete'} size={14} tooltip={{ title: translate('deleteFloor') }} />
                                    </div>
                                    <div className={styles.deleteDevices} onClick={() => onDSListChange([], index)}>
                                        <Icon
                                            type={'delete'}
                                            size={14}
                                            tooltip={{ title: translate('deleteAllDevices') }}
                                        />
                                    </div>
                                    <EditText
                                        value={floor.name}
                                        onChange={(value: string) => {
                                            onFloorNameChange(value, floor.id)
                                        }}
                                        containerClass={styles.separator}
                                        className={styles.input}
                                        label={translate('floorNumber')}
                                    />
                                    <div className={styles.devicesTitle}>{translate('selectedDevices')}</div>
                                    {floor.digitalSignages.map((device: any) => {
                                        return (
                                            <div className={styles.device}>
                                                <Icon
                                                    type={device.type === 'digitalSignage' ? 'display' : 'folder'}
                                                    size={14}
                                                />
                                                <div className={styles.deviceName}>{device.name}</div>
                                            </div>
                                        )
                                    })}
                                    <CatalogSelectDevices
                                        showButton={true}
                                        selectedItems={floor.digitalSignages}
                                        onSelectInDetails={(digitalSignages: any) => {
                                            onDSListChange(digitalSignages, index)
                                        }}
                                        disableShowDeviceList={true}
                                    />
                                </div>
                            )
                        })}
                        <Button mod="fill" className={styles.button} onClick={onFloorAdd}>
                            {translate('addFloor')}
                        </Button>
                    </div>
                    <div className={styles.controls}>
                        <Button mod={'withBorder'} className={styles.button} onClick={onClose}>
                            {translate('cancel')}
                        </Button>
                        <Button mod="fill" className={styles.button} onClick={onSave} disabled={isValid()}>
                            {translate(unit.id ? 'save' : 'create')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    ) : null
}
